<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
    metaInfo: {
      title: 'Elegant Granite',
    },
  }
</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Roboto+Slab:100,300,400,700');
@import url('https://fonts.googleapis.com/css?family=Coiny');
@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(/static/fonts/Milliard-Light.woff2);
  /*unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;*/
}
@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(/static/fonts/Milliard-Medium.woff2);
}
@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(/static/fonts/Milliard-Bold.woff2);
}
#app {
  width: 100%;
  height: 100%;
  position: relative;
}
.text-center{
  text-align: center !important;
}
*, *::before, *::after{
  box-sizing: border-box;
}
body {
  width: 100%;
  margin: 0;
  padding: 0 !important;
  background-color: #ffffff;
  overflow: initial!important;
  color: #000;
  font-family: 'Raleway',sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  /* user-select: none; */
}
body, input, textarea, button, select {
  line-height: normal;
  font-family: 'Raleway',sans-serif;
}


ul, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
a{
  color: #000000;
  text-decoration:none;
}

  body{
    padding-top: 190px !important;
    overflow-x: hidden !important;
  }
  .body_top{
    padding-top: 175px !important;
  }

  .pointer{
    cursor: pointer;
  }

  @media only screen and (max-width: 1299px) {
    body{
      padding-top: 180px !important;
    }
  }
  @media only screen and (max-width: 767px) {
    body{
      padding-top: 98px !important;
    }
  }
  @media only screen and (max-width: 479px){
    body{
      padding-top: 94px !important;
    }
  }

  ::-webkit-scrollbar {
    width: 12px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue